

export const ProblemReportingTypes = {
    GET_PROBLEM_REPORTING : 'GET_PROBLEM_REPORTING',
    CLEAR_PROBLEM_REPORTING : 'CLEAR_PROBLEM_REPORTING',
}